import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal } from '../modal';
import { ModalHeaderComponent } from '../components/modal-header/modal-header.component';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, Subscription, debounceTime, finalize, of, switchMap } from 'rxjs';
import { CustomersService } from '../../services/entities/users/customer/customers.service';
import { SelectedOrgService } from '../../services/selected-org.service';
import { IUser } from '../../models/user/user.model';
import { UserNameOrEmailPipe } from '../../pipes/user-name-or-email.pipe';
import { TranslateModule } from '@ngx-translate/core';

export type FindCustomerModalResult = Subject<IUser | null>;

@Component({
  selector: 'app-find-customer-modal',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,TranslateModule,
    InputTextModule, ListboxModule,
    ModalHeaderComponent, UserNameOrEmailPipe,
  ],
  templateUrl: './find-customer-modal.component.html',
  styleUrls: ['./find-customer-modal.component.scss']
})
export class FindCustomerModalComponent extends Modal implements OnInit, OnDestroy {

  @Output() result: FindCustomerModalResult = new Subject<IUser | null>();

  queryFC = new FormControl('', { nonNullable: true });
  selectedCustomerFC = new FormControl<IUser | null>(null);

  searched: boolean = false;
  fetching: boolean = false;
  customers: IUser[] = [];

  subs: Subscription[] = [];

  constructor(
    private customersService: CustomersService,
    public selectedOrg: SelectedOrgService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.subs.push(
      this.queryFC.valueChanges.pipe(
        debounceTime(300),
        switchMap((query) => {
          const orgId = this.selectedOrg.getCurrentValue();
          if (query.length < 3 || !orgId) return of(null);
          this.fetching = true;
          return this.customersService.whisper({
            orgId,
            query
          }).pipe(finalize(() => this.fetching = false));
        }
      )).pipe(
        finalize(() => this.fetching = false)
      ).subscribe({
        next: (res) => {
          this.searched = true;
          this.customers = res;
        },
        complete: () => {
          this.fetching = false;
        }
      }),

      this.selectedCustomerFC.valueChanges.subscribe(customer => {
        this.result.next(customer);
        this.close();
      })
    );
  }


  override ngOnDestroy(): void {
    super.ngOnDestroy();
    
    this.subs.forEach(s => s.unsubscribe());
  }

}
